import CommonRouter from './CommonRouter'
import { notificationRoutes } from '../routes/NotificationRoutes'
const CurrentNavigator = CommonRouter('MyNotifications', notificationRoutes.Notifications)
export default CurrentNavigator
